import styled from "styled-components";
import { theme } from "../../theme";

export const StyledAccordion = styled.div<{ disabled?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 24px;
  position: relative;
  button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.2rem;
    border: none;
    font-size: 14px;
    padding: 12px;
    background-color: ${theme.backgroundColor.primaryGray}
      ${({ disabled }) => (disabled ? "!important" : "")};
    outline: none;
    font-weight: 500;
    cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
    color: ${({ disabled }) =>
      disabled ? theme.textColor.quaternaryGray : theme.textColor.primaryBlack};
    &:hover {
      background-color: ${theme.backgroundColor.hoverGray};
      transition: all 0.3s ease;
    }
    svg {
      width: 20px;
      height: 20px;
      position: relative;
      top: -1px;
    }
  }
  div.body-open {
    display: flex;
    max-height: 100%;
    transition: display 1s ease;
    width: 100%;
    padding: 24px 0 0 0;
    flex-direction: column;
  }
  div.body-close {
    max-height: 0;
    transition: display 1s ease;
    overflow: hidden;
    width: 100%;
    padding: 0;
  }
`;
